import { render, staticRenderFns } from "./SeparatorPink.vue?vue&type=template&id=2d613f3b&"
import script from "./SeparatorPink.vue?vue&type=script&lang=js&"
export * from "./SeparatorPink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports